import * as Dialog from '@radix-ui/react-dialog'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useTreeState } from '../../../stores/Root'
import { Box, Column, Row } from '../../core/Components'
import { Modal } from '../../core/Modal'
import { Subtitle } from '../../core/Subtitle'
import { Title } from '../../core/Title'
import { StudioActivityBarIcon } from '../StudioActivityBar'

const Body: FC = observer(() => {
  const { studio } = useTreeState()

  const onClick = () => {
    studio.resetToNewSongState()
  }

  return (
    <Box css={{ width: '400px' }}>
      <Title>New track</Title>
      <Column>
        <Subtitle>
          Are you sure would like to create a new track? All unsaved changes will be lost.
        </Subtitle>
        <Row>
          <Dialog.Close className="studio-modal-button-outline me-3" style={{ width: '50%' }}>
            Cancel
          </Dialog.Close>
          <Dialog.Close
            className="studio-modal-button-fill d-flex justify-content-center align-items-center"
            style={{ width: '50%' }}
            onClick={onClick}
          >
            Confirm
          </Dialog.Close>
        </Row>
      </Column>
    </Box>
  )
})

const Trigger: FC = () => (
  <StudioActivityBarIcon title="New Track" src="/static/icons/studio_plus.svg" />
)

const StudioDeleteComponent: FC = () => (
  <Modal
    trigger={
      <Box>
        <Trigger />
      </Box>
    }
  >
    <Body />
  </Modal>
)

export default StudioDeleteComponent
